import { render } from "./StageRegions.vue?vue&type=template&id=c7a4c2ee&scoped=true"
import script from "./StageRegions.vue?vue&type=script&lang=js"
export * from "./StageRegions.vue?vue&type=script&lang=js"

import "./StageRegions.vue?vue&type=style&index=0&id=c7a4c2ee&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a4c2ee"]])

export default __exports__